<template>
  <div class="modal">
    <b-modal
      id="show-modal-observations"
      ref="showModalObservations"
      @show="initializeUserAndDate()"
      size="lg"
      class="mt-4"
      hide-footer
    >
      <template #modal-title>
        <h5 class="modal-title">Nova Observação</h5>
      </template>
      <validation-observer ref="observer" v-slot="{ handleSubmit, invalid }">
        <b-form @submit.stop.prevent="handleSubmit()" class="form" autocomplete="off">
          <br />
          <div class="text-center">
            <validation-provider
              name="texto da observação"
              rules="required"
              v-slot="validationContext"
              vid="text"
            >
              <VueEditor 
                v-model="observations_data.text"
                placeholder="Digite a nova informação aqui ..."
                :editor-toolbar="customToolbar"
                :state="getValidationState(validationContext)" />
              <b-form-invalid-feedback>{{
                validationContext.errors[0]
              }}</b-form-invalid-feedback>
            </validation-provider>
          </div>
          <button
            :disabled="invalid"
            @click="returnObservationData()"
            class="btn btn-primary ml-6 my-2 float-right"
          >
            Salvar
          </button>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import companyService from "@/services/company";
import commomsHelperMixin from "@/mixins/commomsHelper";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import commonsTypes from "@/enums/commonsTypes";
export default {
  name: "ObservationsModal",
  emits: ["showClientData"],
  mixins: [commomsHelperMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
    VueEditor,
  },
  data: () => ({
    observations_data: {
      text: "",
      author: "",
      date: "",
      is_edit: false,
    },
    commonsTypes: commonsTypes,
    customToolbar: [
      [{ 'size': ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'align': [] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'script': 'sub'}, { 'script': 'super' }, 'blockquote'],
      ['link', 'clean'],
    ]
  }),
  created() {
    if (this.getIdFromUrl().length == this.commonsTypes.URL_LENGHT) {
      this.is_edit = true;
    }
  },
  methods: {
    returnObservationData() {
      this.$bvModal.hide("show-modal-observations");
      if (this.is_edit) {
        this.insertObservationData();
      } else {
        this.$emit("setObservationData", this.observations_data);
        this.clearObservationsData();
      }
    },
    clearObservationsData() {
      this.observations_data = {};
    },
    initializeUserAndDate() {
      this.observations_data.author = this.$store.getters.user.name;
      this.observations_data.date = new Date().toISOString().split("T")[0];
    },
    insertObservationData() {
      companyService
        .insertEconomicGroupObservation(this.getIdFromUrl(), this.observations_data)
        .then((response) => {
          if (response.data.error) {
            return;
          }
        })
        .catch(() => {
          this.showError("Não foi possível apagar observação.");
        })
        .finally(() => {
          this.clearObservationsData();
          this.$emit("showClientData");
        });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>

<style></style>
